import { ICompanyAddViewModel, ICompanyViewModel, IDepartmentViewModel } from "Interfaces/ICompaniesConfig";
import { CloudFactoryProductViewModel, IImportEmployeeAddViewModel, IImportProductAddViewModel } from "../Converts/ICloudFactoryInterfaces";
import { IEmployeeViewModel } from "Interfaces/IEmployeeConfig";
import { IResourcesViewModel } from "Interfaces/IResourcesConfig";
import { IBrandViewModel } from "pages/Setup/setupConfig";

export const moduleOptions = [
  {
    id: 1,
    name: 'Get Companies',
    description: 'Import companies from Cloud Factory',
  },
  {
    id: 2,
    name: 'Get Users',
    description: 'Import Users from Company: ',
  },
  {
    id: 3,
    name: 'Get Products',
    description: 'Import Products from Cloud Factory',
  },
  {
    id: 4,
    name: 'API Documentation',
    description: 'Access API usage and examples',
  },
];

export const enum ShowRightSideEnum {
  companies = 'companies',
  employee = 'employee',
  resource = 'resource',
  employees = 'employees',
  resources = 'resources',
  products = 'products',
  allProducts = 'allProducts',
}
export interface ICloudFactoryData {
  id: string | null;
  // List of companies fetched from Bluu
  bluuCompanies: ICompanyViewModel[];
  companies: ICompanyAddViewModel[];
  localCompany: ICompanyViewModel;
  companyEmployees: IImportEmployeeAddViewModel[];
  products: IImportProductAddViewModel[];
  cloudTempProducts: CloudFactoryProductViewModel[];
  selectedCompany: ICompanyViewModel | null;
  selectedCompanyEmployeeList: IEmployeeViewModel[];
  selectedEmployee: IImportEmployeeAddViewModel | null;
  selectedResource: IResourcesViewModel | null;
  selectedAddCompany: ICompanyAddViewModel | null;
  departments: IDepartmentViewModel[];
  brands: IBrandViewModel[];
  rightSideView: ShowRightSideEnum;
  nextCompany: boolean;
  page: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  currentPage: number;
  isReloadCompanies: boolean;
}

export const cloudFactoryInitialState: ICloudFactoryData = {
  id: null,
  bluuCompanies: [] as unknown as ICompanyViewModel[],
  companies: [] as unknown as ICompanyAddViewModel[],
  localCompany: {} as unknown as ICompanyViewModel,
  companyEmployees: [],
  products: [],
  cloudTempProducts: [] as unknown as CloudFactoryProductViewModel[],
  selectedCompany: null,
  selectedCompanyEmployeeList: [],
  selectedEmployee: null,
  selectedResource: null,
  selectedAddCompany: null,
  departments: [],
  brands: [],
  rightSideView: ShowRightSideEnum.companies,
  nextCompany: false,
  page: 1,
  pageSize: 10,
  totalPages: 1,
  totalRecords: 0,
  currentPage: 1,
  isReloadCompanies: true,
};

export type CloudFactoryAction =
  | { type: 'SET_BLUU_COMPANIES'; payload: ICompanyViewModel[] }
  | { type: 'SET_ID'; payload: string }
  | { type: 'SET_IS_RELOAD_COMPANIES'; payload: boolean }
  | { type: 'SET_COMPANIES'; payload: ICompanyAddViewModel[] }
  | {
      type: 'SET_LOCAL_COMPANY';
      payload: ICompanyViewModel;
    }
  | { type: 'SET_COMPANY_EMPLOYEES'; payload: IImportEmployeeAddViewModel[] }
  | { type: 'SET_PRODUCTS'; payload: IImportProductAddViewModel[] }
  | { type: 'ADD_PRODUCT'; payload: IImportProductAddViewModel }
  | { type: 'SET_SELECTED_COMPANY'; payload: ICompanyViewModel | null }
  | { type: 'SET_SELECTED_COMPANY_EMPLOYEES'; payload: IEmployeeViewModel[] }
  | { type: 'CLEAR_SELECTED_COMPANY_RELATED_STATE' }
  | {
      type: 'SET_SELECTED_EMPLOYEE';
      payload: IImportEmployeeAddViewModel | null;
    }
  | { type: 'SET_SELECTED_RESOURCE'; payload: IResourcesViewModel | null }
  | { type: 'SET_SELECTED_ADD_COMPANY'; payload: ICompanyAddViewModel | null }
  | { type: 'SET_DEPARTMENTS'; payload: IDepartmentViewModel[] }
  | { type: 'SET_BRANDS'; payload: IBrandViewModel[] }
  | { type: 'SET_RIGHT_SIDE_VIEW'; payload: ShowRightSideEnum }
  | { type: 'REMOVE_COMPANY_PRODUCTS'; payload: string[] }
  | { type: 'REMOVE_COMPANY_EMPLOYEES'; payload: string[] }
  | { type: 'REMOVE_SELECTED_COMPANY'; payload: string }
  | { type: 'SET_NEXT_COMPANY'; payload: boolean }
  | {
      type: 'ADD_CLOUD_FACTORY_TEMP_PRODUCTS';
      payload: CloudFactoryProductViewModel[];
    }
  | {
      type: 'CLEAR_CLOUD_FACTORY_TEMP_PRODUCTS';
      payload: CloudFactoryProductViewModel[];
    }
  | {
      type: 'SET_PAGINATION';
      payload: {
        page: number;
        pageSize: number;
        totalPages: number;
        totalRecords: number;
        currentPage: number;
      };
    }
  | { type: 'SET_CURRENT_PAGE'; payload: number };

export const cloudFactoryReducer = (
  state: ICloudFactoryData,
  action: CloudFactoryAction
): ICloudFactoryData => {
  switch (action.type) {
    case 'CLEAR_SELECTED_COMPANY_RELATED_STATE':
      return {
        ...state,
        selectedCompany: null,
        selectedCompanyEmployeeList: [],
        selectedEmployee: null,
        selectedResource: null,
        selectedAddCompany: null,
      };
    case 'SET_BLUU_COMPANIES':
      return { ...state, bluuCompanies: action.payload };
    case 'SET_ID':
      return { ...state, id: action.payload };
    case 'SET_IS_RELOAD_COMPANIES':
      return { ...state, isReloadCompanies: action.payload };
    case 'SET_COMPANIES':
      return { ...state, companies: action.payload };
    case 'SET_LOCAL_COMPANY':
      console.log('ccc : SET_LOCAL_COMPANY  1', action.payload);
      return { ...state, localCompany: action.payload };
    case 'SET_PRODUCTS':
      return { ...state, products: action.payload };
    case 'ADD_PRODUCT':
      return { ...state, products: [...state.products, action.payload] };
    case 'ADD_CLOUD_FACTORY_TEMP_PRODUCTS':
      console.log('III : ADD_CLOUD_FACTORY_TEMP_PRODUCTS', action.payload);
      return {
        ...state,
        cloudTempProducts: [...state.cloudTempProducts, ...action.payload],
      };
    case 'CLEAR_CLOUD_FACTORY_TEMP_PRODUCTS':
      console.log('III : CLEAR_CLOUD_FACTORY_TEMP_PRODUCTS', action.payload);
      return {
        ...state,
        cloudTempProducts: [],
      };
    case 'SET_COMPANY_EMPLOYEES':
      console.log('qqq : SET_COMPANY_EMPLOYEES', action.payload);
      return { ...state, companyEmployees: action.payload };
    case 'SET_SELECTED_COMPANY':
      console.log('Selected company: action.payload ', action.payload);
      return { ...state, selectedCompany: action.payload };
    case 'SET_SELECTED_COMPANY_EMPLOYEES':
      return { ...state, selectedCompanyEmployeeList: action.payload };
    case 'SET_SELECTED_EMPLOYEE':
      return { ...state, selectedEmployee: action.payload };
    case 'SET_SELECTED_RESOURCE':
      return { ...state, selectedResource: action.payload };
    case 'SET_SELECTED_ADD_COMPANY':
      return { ...state, selectedAddCompany: action.payload };
    case 'SET_DEPARTMENTS':
      return { ...state, departments: action.payload };
    case 'SET_BRANDS':
      return { ...state, brands: action.payload };
    case 'SET_RIGHT_SIDE_VIEW':
      return { ...state, rightSideView: action.payload };
    case 'REMOVE_COMPANY_PRODUCTS':
      return {
        ...state,
        products: state.products.filter(
          (product) => !action.payload.includes(product.thirdPartyId.toString())
        ),
      };
    case 'REMOVE_COMPANY_EMPLOYEES':
      return {
        ...state,
        companyEmployees: state.companyEmployees.filter(
          (employee) => !action.payload.includes(employee.email)
        ),
      };
    case 'REMOVE_SELECTED_COMPANY':
      return {
        ...state,
        companies: state.companies.filter(
          (company) => !action.payload.includes(company.email)
        ),
      };
    case 'SET_NEXT_COMPANY':
      return { ...state, nextCompany: action.payload };
    case 'SET_PAGINATION':
      return {
        ...state,
        page: action.payload.page,
        pageSize: action.payload.pageSize,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        currentPage: action.payload.currentPage,
      };
    case 'SET_CURRENT_PAGE':
      return { ...state, currentPage: action.payload };
    default:
      return state;
  }
};